import classNames from 'classnames'

import { ITableProps } from 'core-components/library/list/types'

import styles from './PlaceholderRows.module.scss'

interface IPlaceholderRows {
  columnsCount: number
  rowsCount: number
  noData?: boolean
  hasHierarchy?: boolean
  useRowCheckbox?: boolean
  isSelect?: boolean
  placeholderContent?: ITableProps['placeholderContent']
}

export const PlaceholderRows = ({
  columnsCount,
  rowsCount,
  placeholderContent,
  useRowCheckbox,
  isSelect,
  noData,
  hasHierarchy,
}: IPlaceholderRows) => {
  const columnsLength = columnsCount + +!!useRowCheckbox + +!!hasHierarchy
  const rowStyle = !noData
    ? { evenRow: styles.loadingRowEven, oddRow: styles.loadingRowOdd }
    : { evenRow: styles.emptyRowEven, oddRow: styles.emptyRowOdd }
  const rows = []
  const rowsPerPage = rowsCount

  const renderPlaceholder = () => {
    let placeholderText = 'Nothing to show'
    if (placeholderContent) {
      const customPlaceholder = placeholderContent()
      if (typeof customPlaceholder === 'string') {
        placeholderText = customPlaceholder
      } else {
        return customPlaceholder
      }
    }
    const selectClass = isSelect && noData ? styles[`noDataText--inSelect`] : ''
    return <div className={classNames(styles.noDataText, selectClass)}>{placeholderText}</div>
  }

  if (isSelect && noData) {
    rows.push(
      <tr key={`row-${rows.length}`} className={classNames(styles.emptyRow, rowStyle.evenRow)}>
        <td colSpan={columnsCount}>{renderPlaceholder()}</td>
      </tr>
    )
    return <>{rows}</>
  }
  for (let i = 0; i < rowsPerPage; i++) {
    rows.push(
      <tr
        key={i}
        className={classNames(styles.emptyRow, i % 2 === 0 ? rowStyle.evenRow : rowStyle.oddRow)}
      >
        <td colSpan={columnsLength}>
          {noData && i === Math.ceil(rowsPerPage / 2) - 1 ? renderPlaceholder() : ''}
        </td>
      </tr>
    )
  }
  return <>{rows}</>
}
